<gs1-header [img]="'../assets/images/logo-gs1-france.png'" [appName]="'CodeOnline GLN'" [rootLink]="connectedUser ? '/account' : '/connected'" [connected]="connectedUser" [breakWidth]="700" [profileLabel]="user ? getUserName() : 'Mon profil'">
  <a *ngIf="connectedUser" routerLink="/mes-gln" (click)="resetSearch()">Mes GLN</a>
  <a *ngIf="connectedUser" routerLink="/recherche" (click)="forceAccountRefresh()">Rechercher un GLN</a>
  <div id="account-popin">
      <a class="gs1-little gs1-link" (click)="logout()"><i class="bi bi-box-arrow-right gs1-small"></i> Se déconnecter</a>
      <a class="gs1-little gs1-link" *ngIf="canChangeCompany" (click)="changeCompany()"><i class="bi bi-house-door gs1-small"></i> Utiliser une autre entreprise</a>
  </div>
</gs1-header>
<gs1-notifications></gs1-notifications>
<gs1-loading></gs1-loading>
<div class="router-container">
  <router-outlet></router-outlet>
</div>
<gs1-footer [breakWidth]="700" (click)="forceAccountRefresh();resetSearch()">
  <a href="https://www.gs1.fr/nous-contacter" target="_blank">Nous contacter</a>
  <a href="https://www.gs1.fr/foire-aux-questions" target="_blank">FAQ</a>
  <a target="_blank" href="/assets/files/CONDITIONS GENERALES D'UTILISATION - Outil de gestion des GLN 28072022.pdf">Conditions générales d'utilisation</a>
  <a href="https://www.gs1.fr/politique-confidentialite" target="_blank">Politique de confidentialité</a>
  <a (click)="forceAccountRefresh();resetSearch()" routerLink="/mentions-legales">Mentions légales</a>
</gs1-footer>
